import type MapEntityBase from "../../map-entities/map-entity-base";
import type { MapEntityFocusContextState } from "../types";

/**
 * Categories of models that are included in the icon layer
 */
const CategoriesInIconLayer = ["blockValve", "irrigationDevice", "thirdPartyDevice", "SensoterraMoisture"];
export const mapEntityBelongsInIconLayer = ({ mapEntity }: { mapEntity: MapEntityBase }) =>
    Boolean(mapEntity?.model && CategoriesInIconLayer.includes(mapEntity?.model.category));

/**
 * Determines how an icon should appear (what props to pass) based on the focus context state
 *
 * Dimming is deliberately absent: `applyFocus` is the single authority for it, and a second `dimmed`
 * derived here could disagree with the cluster that absorbed the same marker.
 */
export const makeMarkerPropsFromContextState = (state: MapEntityFocusContextState) => {
    switch (state) {
        case "hidden":
            return {
                hidden: true,
            };
        case "focused":
            return {
                highlighted: true,
            };
        case "inactive":
        case "selected":
        case "active":
            return {};
        default:
            return {};
    }
};
